import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieHelperService } from '../../../../shared/services/cookie-helper.service';

@Injectable()
export class PrequalGuard implements CanActivate {

    constructor(private cookieService: CookieHelperService, private router: Router) { }

    canActivate() {
        const selectedOffer = this.cookieService._getCookie('selectedOffer');
        const prequalResponseCookie = this.cookieService._getCookie('prequalResponse');
        // Ignore Guard If Session Is ClassicCars //
        if (prequalResponseCookie !== undefined && !this.cookieService.isClassic) {
            if (prequalResponseCookie.data.hasOwnProperty('isPrequal')) {
                if (prequalResponseCookie.data.isPrequal === true) {
                    if (selectedOffer === null || selectedOffer === undefined) {
                        this.router.navigate(['auto-loans/offer'], {replaceUrl: true});
                    } else {
                        this.router.navigate(['auto-loans/summary'], {replaceUrl: true});
                    }
                    return false;
                }
            }
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/prequalifying-step-forms/containers/prequalifying-step-forms/prequal.guard.ts